export const azureClientId = 'ec417591-8a6a-4953-8bbe-a05f56af6b49';
